import { Component, OnInit } from "@angular/core";
import { formatDate } from "@angular/common";
import { Router } from "@angular/router";
import { GeneralService } from "../general.service";
import { NgxSpinnerService } from "ngx-spinner";
import { MatSnackBar } from "@angular/material";
import { AuthService } from "../auth/auth.service";
import * as moment from "moment";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-add-patients",
  templateUrl: "./add-patients.component.html",
  styleUrls: ["./add-patients.component.css"],
})
export class AddPatientsComponent implements OnInit {
  maxDate = new Date();
  roleId = sessionStorage.getItem("roleId");
  showError!: boolean;
  treatmentname = "CMD";
  isPatientDataCreated = false;

  today = new Date().toISOString().split("T")[0];
  facilityType = sessionStorage.getItem("facilityType");
  districtName = sessionStorage.getItem("district");
  submittingStaff!: string;
  facilityName = sessionStorage.getItem("hospitalName");
  facilityId = sessionStorage.getItem("facilityId");
  isReportAlreadySubmitted = false;

  reportingMonthyear!: string; // This will hold the selected month and year in 'MM-yyyy' format
  repMY!: string;

  // Epilepsy
  epi_old_male!: number;
  epi_old_female!: number;
  epi_new_male!: number;
  epi_new_female!: number;
  epi_ip_male!: number;
  epi_ip_female!: number;

  // Headache
  headache_old_male!: number;
  headache_old_female!: number;
  headache_new_male!: number;
  headache_new_female!: number;
  headache_ip_male!: number;
  headache_ip_female!: number;

  //Stroke
  stroke_old_male!: number;
  stroke_old_female!: number;
  stroke_new_male!: number;
  stroke_new_female!: number;
  stroke_ip_male!: number;
  stroke_ip_female!: number;

  //Dementia
  dementia_old_male!: number;
  dementia_old_female!: number;
  dementia_new_male!: number;
  dementia_new_female!: number;
  dementia_ip_male!: number;
  dementia_ip_female!: number;

  //Parkinsons
  park_old_male!: number;
  park_old_female!: number;
  park_new_male!: number;
  park_new_female!: number;
  park_ip_male!: number;
  park_ip_female!: number;

  //Other Neurological Cases
  onc_old_male!: number;
  onc_old_female!: number;
  onc_new_male!: number;
  onc_new_female!: number;
  onc_ip_male!: number;
  onc_ip_female!: number;

  //Bell's Palsy
  bells_old_male!: number;
  bells_old_female!: number;
  bells_new_male!: number;
  bells_new_female!: number;
  bells_ip_male!: number;
  bells_ip_female!: number;

  //Diabetic Neuropathy
  diabetic_old_male!: number;
  diabetic_old_female!: number;
  diabetic_new_male!: number;
  diabetic_new_female!: number;
  diabetic_ip_male!: number;
  diabetic_ip_female!: number;

  //Peripheral Neuropathy
  peripheral_old_male!: number;
  peripheral_old_female!: number;
  peripheral_new_male!: number;
  peripheral_new_female!: number;
  peripheral_ip_male!: number;
  peripheral_ip_female!: number;

  //Other Neurological Cases(TeleNeurology)

  //Bell's Palsy
  tele_bells_old_male!: number;
  tele_bells_old_female!: number;
  tele_bells_new_male!: number;
  tele_bells_new_female!: number;
  tele_bells_ip_male!: number;
  tele_bells_ip_female!: number;

  //Diabetic Neuropathy
  tele_diabetic_old_male!: number;
  tele_diabetic_old_female!: number;
  tele_diabetic_new_male!: number;
  tele_diabetic_new_female!: number;
  tele_diabetic_ip_male!: number;
  tele_diabetic_ip_female!: number;

  //Peripheral Neuropathy
  tele_peripheral_old_male!: number;
  tele_peripheral_old_female!: number;
  tele_peripheral_new_male!: number;
  tele_peripheral_new_female!: number;
  tele_peripheral_ip_male!: number;
  tele_peripheral_ip_female!: number;

  //Non Neurological Cases (Others)
  oth_old_male!: number;
  oth_old_female!: number;
  oth_new_male!: number;
  oth_new_female!: number;
  oth_ip_male!: number;
  oth_ip_female!: number;

  // PHC
  ref_phc_old_male!: number;
  ref_phc_old_female!: number;
  ref_phc_new_male!: number;
  ref_phc_new_female!: number;
  ref_phc_ip_male!: number;
  ref_phc_ip_female!: number;

  // CHC
  ref_chc_old_male!: number;
  ref_chc_old_female!: number;
  ref_chc_new_male!: number;
  ref_chc_new_female!: number;
  ref_chc_ip_male!: number;
  ref_chc_ip_female!: number;

  // ASHA
  ref_asha_old_male!: number;
  ref_asha_old_female!: number;
  ref_asha_new_male!: number;
  ref_asha_new_female!: number;
  ref_asha_ip_male!: number;
  ref_asha_ip_female!: number;

  // CHO
  ref_cho_old_male!: number;
  ref_cho_old_female!: number;
  ref_cho_new_male!: number;
  ref_cho_new_female!: number;
  ref_cho_ip_male!: number;
  ref_cho_ip_female!: number;

  // Teleneurology - Other Neurological Cases
  tele_onc_old_male!: number;
  tele_onc_old_female!: number;
  tele_onc_new_male!: number;
  tele_onc_new_female!: number;
  tele_onc_ip_male!: number;
  tele_onc_ip_female!: number;

  // Teleneurology - Headache
  tele_headache_old_male!: number;
  tele_headache_old_female!: number;
  tele_headache_new_male!: number;
  tele_headache_new_female!: number;
  tele_headache_ip_male!: number;
  tele_headache_ip_female!: number;

  // Teleneurology - Stroke
  tele_stroke_old_male!: number;
  tele_stroke_old_female!: number;
  tele_stroke_new_male!: number;
  tele_stroke_new_female!: number;
  tele_stroke_ip_male!: number;
  tele_stroke_ip_female!: number;

  // Teleneurology - Epilepsy
  tele_epilepsy_old_male!: number;
  tele_epilepsy_old_female!: number;
  tele_epilepsy_new_male!: number;
  tele_epilepsy_new_female!: number;
  tele_epilepsy_ip_male!: number;
  tele_epilepsy_ip_female!: number;

  // Teleneurology - Dementia
  tele_dementia_old_male!: number;
  tele_dementia_old_female!: number;
  tele_dementia_new_male!: number;
  tele_dementia_new_female!: number;
  tele_dementia_ip_male!: number;
  tele_dementia_ip_female!: number;

  // Teleneurology - Parkinsonism
  tele_parkinson_old_male!: number;
  tele_parkinson_old_female!: number;
  tele_parkinson_new_male!: number;
  tele_parkinson_new_female!: number;
  tele_parkinson_ip_male!: number;
  tele_parkinson_ip_female!: number;

  //Teleneurology -

  remarks!: string;

  validPatientData = false;

  constructor(
    private router: Router,
    private generalService: GeneralService,
    private spinn: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private authService: AuthService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.setFacilityName();
    this.setFacilityType();
    this.setDistrictName();
  }

  cancel() {
    if (this.roleId == "1") {
      this.router.navigate(["adminDashboard"], { replaceUrl: true });
    } else {
      this.router.navigate(["dashboard"], { replaceUrl: true });
    }
  }

  

  setFacilityName(): void {
    const facilityId = sessionStorage.getItem("facilityId");

    if (facilityId && +facilityId !== 0) {
      const hospitalName = sessionStorage.getItem("hospitalName");
      // console.log("Working");
      if (hospitalName) {
        this.facilityName = hospitalName;
      } else {
        console.error("No hospitalName found in session storage");
      }
    } else {
      const lastName = sessionStorage.getItem("lastName");
      if (lastName) {
        this.facilityName = lastName;
      } else {
        console.error("No facilityId or lastName found in session storage");
      }
    }
  }

  setFacilityType(): void {
    const roleId = sessionStorage.getItem("roleId");

    if (roleId) {
      const roleMap: { [key: string]: string } = {
        "1": "Admin",
        "2": "District User",
        "3": "Taluka User",
        "4": "PHC",
        "5": "CHC",
        "6": "District Psy",
        "7": "Super Admin",
        "8": "District Hospital",
        "9": "Taluka Hospital",
        "10": "Other Facility",
        "11": "HWC User",
        "12": "HWC admin",
        "13": "District Surveillance Officer",
        "14": "Jail",
        "15": "Medical College",
        "16": "Dental College",
      };

      const facilityType = roleMap[roleId];
      if (facilityType) {
        this.facilityType = facilityType;
      } else {
        console.error(`No facility type found for roleId: ${roleId}`);
      }
    } else {
      console.error("No roleId found in session storage");
    }
  }

  setDistrictName(): void {
    const districtId = sessionStorage.getItem("districtId");

    if (districtId) {
      const url = `${environment.baseUrl}/fetchDistrictById`;
      this.http.post<any>(url, { districtid: districtId }).subscribe(
        (response) => {
          this.districtName = response.district;
        },
        (error) => {
          console.error("Error fetching district details:", error);
        }
      );
    } else {
      console.error("No districtId found in session storage");
    }
  }

  createPatientData() {
    const safeStringify = (value: any): string => {
      if (value === undefined || value === null || value === "") {
        return "0";
      }
      return String(value);
    };

   const patientObject = {
  stateId: sessionStorage.getItem("stateId")
    ? Number(sessionStorage.getItem("stateId"))
    : null,

  districtId: sessionStorage.getItem("districtId")
    ? Number(sessionStorage.getItem("districtId"))
    : null,

  talukaId: sessionStorage.getItem("talukaId")
    ? Number(sessionStorage.getItem("talukaId"))
    : null,

  phcId: sessionStorage.getItem("phcId")
    ? Number(sessionStorage.getItem("phcId"))
    : null,

  chcId: sessionStorage.getItem("chcId")
    ? Number(sessionStorage.getItem("chcId"))
    : null,

  facilityId: sessionStorage.getItem("facilityId")
    ? Number(sessionStorage.getItem("facilityId"))
    : null,

  userId: sessionStorage.getItem("userId")
    ? Number(sessionStorage.getItem("userId"))
    : null,

      reportingMonthyear: this.formatDate(this.reportingMonthyear),
      reportingMonthYearStr: this.formatDate(this.reportingMonthyear),
      nameOfReportSubmitStaff: this.submittingStaff || null,
      reportingDateStr: this.formatDate(this.today),

      // Epilepsy
      epi_old_male: safeStringify(this.epi_old_male),
      epi_old_female: safeStringify(this.epi_old_female),
      epi_new_male: safeStringify(this.epi_new_male),
      epi_new_female: safeStringify(this.epi_new_female),
      epi_ip_male: safeStringify(this.epi_ip_male),
      epi_ip_female: safeStringify(this.epi_ip_female),

      // Headache
      headache_old_male: safeStringify(this.headache_old_male),
      headache_old_female: safeStringify(this.headache_old_female),
      headache_new_male: safeStringify(this.headache_new_male),
      headache_new_female: safeStringify(this.headache_new_female),
      headache_ip_male: safeStringify(this.headache_ip_male),
      headache_ip_female: safeStringify(this.headache_ip_female),

      // Stroke
      stroke_old_male: safeStringify(this.stroke_old_male),
      stroke_old_female: safeStringify(this.stroke_old_female),
      stroke_new_male: safeStringify(this.stroke_new_male),
      stroke_new_female: safeStringify(this.stroke_new_female),
      stroke_ip_male: safeStringify(this.stroke_ip_male),
      stroke_ip_female: safeStringify(this.stroke_ip_female),

      // Dementia
      dementia_old_male: safeStringify(this.dementia_old_male),
      dementia_old_female: safeStringify(this.dementia_old_female),
      dementia_new_male: safeStringify(this.dementia_new_male),
      dementia_new_female: safeStringify(this.dementia_new_female),
      dementia_ip_male: safeStringify(this.dementia_ip_male),
      dementia_ip_female: safeStringify(this.dementia_ip_female),

      // Parkinson's
      park_old_male: safeStringify(this.park_old_male),
      park_old_female: safeStringify(this.park_old_female),
      park_new_male: safeStringify(this.park_new_male),
      park_new_female: safeStringify(this.park_new_female),
      park_ip_male: safeStringify(this.park_ip_male),
      park_ip_female: safeStringify(this.park_ip_female),

      // Bell's Palsy
      bells_old_male: safeStringify(this.bells_old_male),
      bells_old_female: safeStringify(this.bells_old_female),
      bells_new_male: safeStringify(this.bells_new_male),
      bells_new_female: safeStringify(this.bells_new_female),
      bells_ip_male: safeStringify(this.bells_ip_male),
      bells_ip_female: safeStringify(this.bells_ip_female),

      // Diabetic Neuropathy
      diabetic_old_male: safeStringify(this.diabetic_old_male),
      diabetic_old_female: safeStringify(this.diabetic_old_female),
      diabetic_new_male: safeStringify(this.diabetic_new_male),
      diabetic_new_female: safeStringify(this.diabetic_new_female),
      diabetic_ip_male: safeStringify(this.diabetic_ip_male),
      diabetic_ip_female: safeStringify(this.diabetic_ip_female),

      // Peripheral Neuropathy
      peripheral_old_male: safeStringify(this.peripheral_old_male),
      peripheral_old_female: safeStringify(this.peripheral_old_female),
      peripheral_new_male: safeStringify(this.peripheral_new_male),
      peripheral_new_female: safeStringify(this.peripheral_new_female),
      peripheral_ip_male: safeStringify(this.peripheral_ip_male),
      peripheral_ip_female: safeStringify(this.peripheral_ip_female),

      // Tele Peripheral Neuropathy
      tele_peripheral_old_male: safeStringify(this.tele_peripheral_old_male),
      tele_peripheral_old_female: safeStringify(
        this.tele_peripheral_old_female
      ),
      tele_peripheral_new_male: safeStringify(this.tele_peripheral_new_male),
      tele_peripheral_new_female: safeStringify(
        this.tele_peripheral_new_female
      ),
      tele_peripheral_ip_male: safeStringify(this.tele_peripheral_ip_male),
      tele_peripheral_ip_female: safeStringify(this.tele_peripheral_ip_female),

      // Non Neurological Cases
      oth_old_male: safeStringify(this.oth_old_male),
      oth_old_female: safeStringify(this.oth_old_female),
      oth_new_male: safeStringify(this.oth_new_male),
      oth_new_female: safeStringify(this.oth_new_female),
      oth_ip_male: safeStringify(this.oth_ip_male),
      oth_ip_female: safeStringify(this.oth_ip_female),

      //Other Neurological Cases
      onc_old_male: safeStringify(this.onc_old_male),
      onc_old_female: safeStringify(this.onc_old_female),
      onc_new_male: safeStringify(this.onc_new_male),
      onc_new_female: safeStringify(this.onc_new_female),
      onc_ip_male: safeStringify(this.onc_ip_male),
      onc_ip_female: safeStringify(this.onc_ip_female),

      // PHC Referrals
      ref_phc_old_male: safeStringify(this.ref_phc_old_male),
      ref_phc_old_female: safeStringify(this.ref_phc_old_female),
      ref_phc_new_male: safeStringify(this.ref_phc_new_male),
      ref_phc_new_female: safeStringify(this.ref_phc_new_female),
      ref_phc_ip_male: safeStringify(this.ref_phc_ip_male),
      ref_phc_ip_female: safeStringify(this.ref_phc_ip_female),

      // CHC Referrals
      ref_chc_old_male: safeStringify(this.ref_chc_old_male),
      ref_chc_old_female: safeStringify(this.ref_chc_old_female),
      ref_chc_new_male: safeStringify(this.ref_chc_new_male),
      ref_chc_new_female: safeStringify(this.ref_chc_new_female),
      ref_chc_ip_male: safeStringify(this.ref_chc_ip_male),
      ref_chc_ip_female: safeStringify(this.ref_chc_ip_female),

      // ASHA Referrals
      ref_asha_old_male: safeStringify(this.ref_asha_old_male),
      ref_asha_old_female: safeStringify(this.ref_asha_old_female),
      ref_asha_new_male: safeStringify(this.ref_asha_new_male),
      ref_asha_new_female: safeStringify(this.ref_asha_new_female),
      ref_asha_ip_male: safeStringify(this.ref_asha_ip_male),
      ref_asha_ip_female: safeStringify(this.ref_asha_ip_female),

      // CHO Referrals
      ref_cho_old_male: safeStringify(this.ref_cho_old_male),
      ref_cho_old_female: safeStringify(this.ref_cho_old_female),
      ref_cho_new_male: safeStringify(this.ref_cho_new_male),
      ref_cho_new_female: safeStringify(this.ref_cho_new_female),
      ref_cho_ip_male: safeStringify(this.ref_cho_ip_male),
      ref_cho_ip_female: safeStringify(this.ref_cho_ip_female),

      // Teleneurology - Headache
      tele_headache_old_male: safeStringify(this.tele_headache_old_male),
      tele_headache_old_female: safeStringify(this.tele_headache_old_female),
      tele_headache_new_male: safeStringify(this.tele_headache_new_male),
      tele_headache_new_female: safeStringify(this.tele_headache_new_female),
      tele_headache_ip_male: safeStringify(this.tele_headache_ip_male),
      tele_headache_ip_female: safeStringify(this.tele_headache_ip_female),

      // Teleneurology - Stroke
      tele_stroke_old_male: safeStringify(this.tele_stroke_old_male),
      tele_stroke_old_female: safeStringify(this.tele_stroke_old_female),
      tele_stroke_new_male: safeStringify(this.tele_stroke_new_male),
      tele_stroke_new_female: safeStringify(this.tele_stroke_new_female),
      tele_stroke_ip_male: safeStringify(this.tele_stroke_ip_male),
      tele_stroke_ip_female: safeStringify(this.tele_stroke_ip_female),

      // Teleneurology - Epilepsy
      tele_epilepsy_old_male: safeStringify(this.tele_epilepsy_old_male),
      tele_epilepsy_old_female: safeStringify(this.tele_epilepsy_old_female),
      tele_epilepsy_new_male: safeStringify(this.tele_epilepsy_new_male),
      tele_epilepsy_new_female: safeStringify(this.tele_epilepsy_new_female),
      tele_epilepsy_ip_male: safeStringify(this.tele_epilepsy_ip_male),
      tele_epilepsy_ip_female: safeStringify(this.tele_epilepsy_ip_female),

      // Teleneurology - Dementia
      tele_dementia_old_male: safeStringify(this.tele_dementia_old_male),
      tele_dementia_old_female: safeStringify(this.tele_dementia_old_female),
      tele_dementia_new_male: safeStringify(this.tele_dementia_new_male),
      tele_dementia_new_female: safeStringify(this.tele_dementia_new_female),
      tele_dementia_ip_male: safeStringify(this.tele_dementia_ip_male),
      tele_dementia_ip_female: safeStringify(this.tele_dementia_ip_female),

      // Teleneurology - Parkinsonism
      tele_parkinson_old_male: safeStringify(this.tele_parkinson_old_male),
      tele_parkinson_old_female: safeStringify(this.tele_parkinson_old_female),
      tele_parkinson_new_male: safeStringify(this.tele_parkinson_new_male),
      tele_parkinson_new_female: safeStringify(this.tele_parkinson_new_female),
      tele_parkinson_ip_male: safeStringify(this.tele_parkinson_ip_male),
      tele_parkinson_ip_female: safeStringify(this.tele_parkinson_ip_female),

      //Tele Bell's Palsy
      tele_bells_old_male: safeStringify(this.tele_bells_old_male),
      tele_bells_old_female: safeStringify(this.tele_bells_old_female),
      tele_bells_new_male: safeStringify(this.tele_bells_new_male),
      tele_bells_new_female: safeStringify(this.tele_bells_new_female),
      tele_bells_ip_male: safeStringify(this.tele_bells_ip_male),
      tele_bells_ip_female: safeStringify(this.tele_bells_ip_female),

      // Tele Diabetic Neuropathy
      tele_diabetic_old_male: safeStringify(this.tele_diabetic_old_male),
      tele_diabetic_old_female: safeStringify(this.tele_diabetic_old_female),
      tele_diabetic_new_male: safeStringify(this.tele_diabetic_new_male),
      tele_diabetic_new_female: safeStringify(this.tele_diabetic_new_female),
      tele_diabetic_ip_male: safeStringify(this.tele_diabetic_ip_male),
      tele_diabetic_ip_female: safeStringify(this.tele_diabetic_ip_female),

      // Teleneurology - Other Neurological Cases
      tele_onc_old_male: safeStringify(this.tele_onc_old_male),
      tele_onc_old_female: safeStringify(this.tele_onc_old_female),
      tele_onc_new_male: safeStringify(this.tele_onc_new_male),
      tele_onc_new_female: safeStringify(this.tele_onc_new_female),
      tele_onc_ip_male: safeStringify(this.tele_onc_ip_male),
      tele_onc_ip_female: safeStringify(this.tele_onc_ip_female),

      remarks: this.remarks || null,
    };

    this.spinn.show();

    this.http
      .post(`${environment.baseUrl}/addKabhiNewPatientData`, patientObject)
      .subscribe(
        (res: any) => {
          this.spinn.hide();
          this.snackBar.open(res.saveStatus, "x", { duration: 5000 });
          this.navigateBasedOnRole(); 
        },
        (err) => {
          this.isPatientDataCreated = false;
          this.spinn.hide();

          if (err.status === 409) {
            
            this.snackBar.open(
              err.error.saveStatus ||
                "Data already exists for this month/year. Please select a different month.",
              "x",
              { duration: 8000 }
            );
           
            return; 
          } else {
         
            let errorMessage = "Error saving data. Please try again.";
            if (err.error && err.error.message) {
              errorMessage = err.error.message;
            } else if (err.message) {
              errorMessage = err.message;
            }
            this.snackBar.open(errorMessage, "x", { duration: 5000 });

           
            this.navigateBasedOnRole();
          }
        }
      );
  }

  private navigateBasedOnRole(): void {
    if (this.roleId === "1") {
      this.router.navigate(["adminDashboard"], { replaceUrl: true });
    } else if (["2", "4", "5", "6", "9"].includes(this.roleId!)) {
      this.router.navigate(["distDashboard"], { replaceUrl: true });
    } else {
      this.router.navigate(["dashboard"], { replaceUrl: true });
    }
  }

  validatePatientData() {
    const allFields = [
      this.epi_old_male,
      this.epi_old_female,
      this.epi_new_male,
      this.epi_new_female,
      this.epi_ip_male,
      this.epi_ip_female,
      this.headache_old_male,
      this.headache_old_female,
      this.headache_new_male,
      this.headache_new_female,
      this.headache_ip_male,
      this.headache_ip_female,
      this.stroke_old_male,
      this.stroke_old_female,
      this.stroke_new_male,
      this.stroke_new_female,
      this.stroke_ip_male,
      this.stroke_ip_female,
      this.dementia_old_male,
      this.dementia_old_female,
      this.dementia_new_male,
      this.dementia_new_female,
      this.dementia_ip_male,
      this.dementia_ip_female,
      this.park_old_male,
      this.park_old_female,
      this.park_new_male,
      this.park_new_female,
      this.park_ip_male,
      this.park_ip_female,
      this.bells_old_male,
      this.bells_old_female,
      this.bells_new_male,
      this.bells_new_female,
      this.bells_ip_male,
      this.bells_ip_female,
      this.diabetic_old_male,
      this.diabetic_old_female,
      this.diabetic_new_male,
      this.diabetic_new_female,
      this.diabetic_ip_male,
      this.diabetic_ip_female,
      this.peripheral_old_male,
      this.peripheral_old_female,
      this.peripheral_new_male,
      this.peripheral_new_female,
      this.peripheral_ip_male,
      this.peripheral_ip_female,
      this.tele_bells_old_male,
      this.tele_bells_old_female,
      this.tele_bells_new_male,
      this.tele_bells_new_female,
      this.tele_bells_ip_male,
      this.tele_bells_ip_female,
      this.tele_diabetic_old_male,
      this.tele_diabetic_old_female,
      this.tele_diabetic_new_male,
      this.tele_diabetic_new_female,
      this.tele_diabetic_ip_male,
      this.tele_diabetic_ip_female,
      this.tele_peripheral_old_male,
      this.tele_peripheral_old_female,
      this.tele_peripheral_new_male,
      this.tele_peripheral_new_female,
      this.tele_peripheral_ip_male,
      this.tele_peripheral_ip_female,

      this.oth_old_male,
      this.oth_old_female,
      this.oth_new_male,
      this.oth_new_female,
      this.oth_ip_male,
      this.oth_ip_female,

      // Referral fields
      this.ref_phc_old_male,
      this.ref_phc_old_female,
      this.ref_phc_new_male,
      this.ref_phc_new_female,
      this.ref_phc_ip_male,
      this.ref_phc_ip_female,
      this.ref_chc_old_male,
      this.ref_chc_old_female,
      this.ref_chc_new_male,
      this.ref_chc_new_female,
      this.ref_chc_ip_male,
      this.ref_chc_ip_female,
      this.ref_asha_old_male,
      this.ref_asha_old_female,
      this.ref_asha_new_male,
      this.ref_asha_new_female,
      this.ref_asha_ip_male,
      this.ref_asha_ip_female,
      this.ref_cho_old_male,
      this.ref_cho_old_female,
      this.ref_cho_new_male,
      this.ref_cho_new_female,
      this.ref_cho_ip_male,
      this.ref_cho_ip_female,

      // Teleneurology fields
      this.tele_headache_old_male,
      this.tele_headache_old_female,
      this.tele_headache_new_male,
      this.tele_headache_new_female,
      this.tele_headache_ip_male,
      this.tele_headache_ip_female,
      this.tele_stroke_old_male,
      this.tele_stroke_old_female,
      this.tele_stroke_new_male,
      this.tele_stroke_new_female,
      this.tele_stroke_ip_male,
      this.tele_stroke_ip_female,
      this.tele_epilepsy_old_male,
      this.tele_epilepsy_old_female,
      this.tele_epilepsy_new_male,
      this.tele_epilepsy_new_female,
      this.tele_epilepsy_ip_male,
      this.tele_epilepsy_ip_female,
      this.tele_dementia_old_male,
      this.tele_dementia_old_female,
      this.tele_dementia_new_male,
      this.tele_dementia_new_female,
      this.tele_dementia_ip_male,
      this.tele_dementia_ip_female,
      this.tele_parkinson_old_male,
      this.tele_parkinson_old_female,
      this.tele_parkinson_new_male,
      this.tele_parkinson_new_female,
      this.tele_parkinson_ip_male,
      this.tele_parkinson_ip_female,
    ];

    const hasNegativeValue = allFields.some(
      (field) => field != null && field < 0
    );

    if (hasNegativeValue) {
      this.validPatientData = true;
      this.snackBar.open(
        "Negative value is entered, Please enter valid data !! ",
        "x",
        {
          duration: 5000,
        }
      );
    } else {
      this.validPatientData = false;
    }
  }
  formatDate(date: any): string {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
}
